if (!customElements.get('boltlink-fit')) {
  customElements.define('boltlink-fit', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.step = 0;
      this.form = this.querySelector('form');
      this.steps = [...this.querySelectorAll('[data-step]')];
      this.error = this.querySelector('[data-error]');
      this.unit = 'in';
      this.querySelector('[data-fit-interactive]').hidden = false;
      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        if (this.validateStep() && this.step < 3) this.showStep(this.step + 1);
      });
      this.querySelector('[data-back]').addEventListener('click', () => this.showStep(this.step - 1));
      this.form.addEventListener('change', (event) => {
        if (event.target.name === 'unit') this.convertUnits(event.target.value);
        if (event.target.name === 'item') {
          this.querySelector('[data-ac-note]').hidden = this.form.elements.namedItem('item').value !== 'AC unit';
        }
      });
      this.querySelector('[data-copy]').addEventListener('click', () => this.copySummary());
    }

    fail(message, input) {
      this.error.textContent = message;
      if (input) input.focus();
      else this.error.focus();
      return false;
    }

    validateStep() {
      this.error.textContent = '';
      if (this.step === 0 && !this.form.elements.namedItem('item').value) {
        return this.fail('Choose what you want to cover.', this.form.elements.namedItem('item')[0]);
      }
      if (this.step === 1) {
        const max = this.unit === 'in' ? 500 : 1270;
        for (const dimension of ['width', 'depth', 'height']) {
          const input = this.form.elements[dimension];
          const value = Number(input.value);
          if (!input.value || !Number.isFinite(value) || value < 0.1 || value > max || !input.checkValidity()) {
            return this.fail(`Enter a ${dimension} between 0.1 and ${max} ${this.unit}. For larger items, contact us for help.`, input);
          }
        }
      }
      if (this.step === 2 && !this.form.elements.shape.value) {
        return this.fail('Choose a shape, or select “I’m not sure”.', this.form.elements.shape[0]);
      }
      return true;
    }

    convertUnits(nextUnit) {
      const factor = nextUnit === 'cm' ? 2.54 : 1 / 2.54;
      for (const dimension of ['width', 'depth', 'height']) {
        const input = this.form.elements[dimension];
        if (input.value && Number.isFinite(Number(input.value))) {
          input.value = String(Math.round(Number(input.value) * factor * 100) / 100);
        }
        input.max = nextUnit === 'cm' ? '1270' : '500';
      }
      this.unit = nextUnit;
      this.error.textContent = '';
    }

    showStep(step) {
      this.step = Math.max(0, Math.min(3, step));
      this.steps.forEach((panel, index) => { panel.hidden = index !== this.step; });
      this.querySelectorAll('.bl-fit__progress li').forEach((item, index) => {
        if (index === this.step) item.setAttribute('aria-current', 'step');
        else item.removeAttribute('aria-current');
      });
      this.querySelector('[data-back]').hidden = this.step === 0;
      this.querySelector('[data-next]').hidden = this.step === 3;
      this.querySelector('[data-next]').textContent = this.step === 2 ? 'Review measurements →' : 'Continue →';
      this.querySelector('[data-step-label]').textContent = `Step ${this.step + 1} of 4`;
      this.error.textContent = '';
      if (this.step === 3) this.renderSummary();
      this.steps[this.step].querySelector('h2').focus();
    }

    renderSummary() {
      const fields = this.form.elements;
      const lines = [
        `Item: ${fields.namedItem('item').value}`,
        `Width: ${fields.width.value} ${this.unit}`,
        `Depth: ${fields.depth.value} ${this.unit}`,
        `Height: ${fields.height.value} ${this.unit}`,
        `Shape: ${fields.shape.value}`,
      ];
      if (fields.notes.value.trim()) lines.push(`Notes: ${fields.notes.value.trim()}`);
      if (fields.namedItem('item').value === 'AC unit') {
        lines.push('AC use: confirm manufacturer permits covering while off; remove before operation.');
      }
      lines.push('Cover fit has not been confirmed. Please check the product-specific fitting instructions.');
      this.querySelector('[data-summary]').value = lines.join('\n');
      this.querySelector('[data-shape-note]').hidden = fields.shape.value === 'Rectangular or square';
      this.querySelector('[data-copy-status]').textContent = '';
    }

    async copySummary() {
      const summary = this.querySelector('[data-summary]');
      const status = this.querySelector('[data-copy-status]');
      try {
        await navigator.clipboard.writeText(summary.value);
        status.textContent = 'Measurements copied. Paste them into your message when asking for fit help.';
      } catch {
        // Clipboard access may be unavailable in a theme preview; keep the summary selectable.
        summary.focus();
        summary.select();
        status.textContent = 'Your measurements are selected. Use your device’s Copy command to copy them.';
      }
    }
  });
}
